import { supabase } from '../supabase';
import type { UserFeedback, SubscriptionEvent } from '../../types/interactions';
import {cancelStripeSubscription} from "../api/stripe";

export async function submitUserFeedback(
  userId: string,
  feedbackContent: string,
  feedbackType: string = 'general',
  rating?: number
): Promise<{ data: UserFeedback | null; error: any }> {
  try {
    const { data, error } = await supabase
      .from('user_feedback')
      .insert({
        user_id: userId,
        feedback_type: feedbackType,
        feedback_content: feedbackContent,
        rating
      })
      .select()
      .single();

    return { data, error };
  } catch (error) {
    return { data: null, error };
  }
}

export async function recordSubscriptionEvent(
  userId: string,
  eventType: string,
  cancellationReason?: string,
  wantsReengagement?: boolean
): Promise<{ data: SubscriptionEvent | null; error: any }> {
  try {
    const reengagementDate = wantsReengagement
      ? new Date(Date.now() + 90 * 24 * 60 * 60 * 1000).toISOString() // 3 months from now
      : null;

    const { data, error } = await supabase
      .from('subscription_events')
      .insert({
        user_id: userId,
        event_type: eventType,
        cancellation_reason: cancellationReason,
        wants_reengagement: wantsReengagement || false,
        reengagement_date: reengagementDate
      })
      .select()
      .single();

    await cancelStripeSubscription(userId);

    return { data, error };
  } catch (error) {
    return { data: null, error };
  }
}

export async function getUserFeedback(
  userId: string,
  limit: number = 10
): Promise<{ data: UserFeedback[] | null; error: any }> {
  try {
    const { data, error } = await supabase
      .from('user_feedback')
      .select('*')
      .eq('user_id', userId)
      .order('created_at', { ascending: false })
      .limit(limit);

    return { data, error };
  } catch (error) {
    return { data: null, error };
  }
}
